import React, { Component } from 'react'
import { injectIntl, FormattedMessage } from 'react-intl'
// import Textarea from 'react-textarea-autosize'

const OPEN_MARK = '<mark>'
const CLOSE_MARK = '</mark>'

class HighlightedTextarea extends Component {
  constructor(props) {
    super(props)
    this.state = {
      input: props.value,
    }
    this._handleInputChange = this._handleInputChange.bind(this)
    this._handleScroll = this._handleScroll.bind(this)
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.value !== this.props.value)
      this.setState({ input: this.props.value })
  }

  _handleInputChange(event) {
    this.setState({ input: event.target.value })
    this.props.onChange(event)
  }

  _handleScroll(event) {
    const scrollTop = event.target.scrollTop
    this.refs.backdrop.scrollTop = scrollTop
  }

  _handleRegexHighlight(input, payload, module, colorArray = []) {
    let className = ''
    if (module == 'language' || module == 'rephrase_words' || module == 'presentation') {
      className = 'highlight-red'
    }
    let OPEN_MARK_WITH_CLASS = '<mark class="' + className + '">'
    let phrase;
    let regex;
    if (payload instanceof RegExp) {
      phrase = payload.source;
      phrase = phrase.replace(/\\b/g, '');
      regex = new RegExp(phrase, payload.flags || 'gi');
    } else {
      phrase = payload;
      phrase = phrase.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
      regex = new RegExp(phrase, 'gi');
    }

    let result = '';
    let lastIndex = 0;
    let match;
    let matchIndex = 0;
    if (regex.global) regex.lastIndex = 0;
    while ((match = regex.exec(input)) !== null) {
      if (match[0].length === 0) {
        regex.lastIndex++;
        continue;
      }
      const start = match.index;
      const end = start + match[0].length;
      const before = input[start - 1];
      const after = input[end];
      const isBoundary = (char) => !char || !/\w/.test(char);
      if (isBoundary(before) && isBoundary(after)) {
        let colorObj = colorArray.find(obj => obj.text === match[0] && obj.color === 'red');
        if (!colorObj) {
          colorObj = colorArray.find(obj => obj.text === match[0] && obj.color === 'green');
        }
        if (colorObj) {
          OPEN_MARK_WITH_CLASS = '<mark class="' + 'highlight-' + colorObj.color + '">'
        }
        result += input.slice(lastIndex, start) + OPEN_MARK_WITH_CLASS + match[0] + CLOSE_MARK;
        lastIndex = end;
        matchIndex++;
      }
    }
    result += input.slice(lastIndex);
    return result;
  }

  _handleArrayHighlight(input, payload) {
    let offset = 0
    payload.forEach(function (element) {
      // insert open tag
      var open = element[0] + offset

      if (element[2]) {
        const OPEN_MARK_WITH_CLASS = '<mark class="' + element[2] + '">'
        input = input.slice(0, open) + OPEN_MARK_WITH_CLASS + input.slice(open)
        offset += OPEN_MARK_WITH_CLASS.length
      } else {
        input = input.slice(0, open) + OPEN_MARK + input.slice(open)
        offset += OPEN_MARK.length
      }

      // insert close tag
      var close = element[1] + offset

      input =
        input.slice(0, close) +
        HighlightedTextarea.CLOSE_MARK +
        input.slice(close)
      offset += HighlightedTextarea.CLOSE_MARK.length
    }, this)
    return input
  }

  getHighlights() {
    let highlightMarks = this.state.input
    let highlightValues = this.props.highlight(highlightMarks)
    const payload = highlightValues[0]
    const module = highlightValues[1]
    const colorArray = highlightValues[2] || []

    // escape HTML
    highlightMarks = highlightMarks
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')

    if (payload) {
      switch (payload.constructor.name) {
        case 'Array':
          highlightMarks = this._handleArrayHighlight(highlightMarks, payload)
          break
        case 'RegExp':
          highlightMarks = this._handleRegexHighlight(
            highlightMarks,
            payload,
            module,
            colorArray
          )
          break
        default:
          throw 'Unrecognized payload type!'
      }
    }

    // this keeps scrolling aligned when input ends with a newline
    highlightMarks = highlightMarks.replace(
      new RegExp('\\n(' + HighlightedTextarea.CLOSE_MARK + ')?$'),
      '\n\n$1'
    )

    // highlightMarks = highlightMarks.replace(new RegExp(HighlightedTextarea.OPEN_MARK, 'g'), '<mark>');
    // highlightMarks = highlightMarks.replace(new RegExp(HighlightedTextarea.CLOSE_MARK, 'g'), '</mark>');
    //
    return highlightMarks
  }

  render() {
    const { intl } = this.props
    return (
      <div className="hwt-container">
        <div className="hwt-backdrop" ref="backdrop">
          <div
            className="hwt-highlights hwt-content"
            dangerouslySetInnerHTML={{ __html: this.getHighlights() }}
          />
        </div>
        <textarea
          aria-label={this.props.placeholder}
          name={this.props.name}
          tabIndex="0"
          placeholder={this.props.placeholder}
          className="hwt-input hwt-content"
          onChange={this._handleInputChange}
          onScroll={this._handleScroll}
          value={this.state.input}
          disabled={this.props.disabled}
          onClick={this.props.onClick}
          onFocus={this.props.onFocus}
          onBlur={this.props.onBlur}
        />
      </div>
    )
  }
}

export default injectIntl(HighlightedTextarea)
